import { Footer } from "./Footer.tsx";

export function PageFooter() {
    return <Footer>
        <div>© CAREL INDUSTRIES S.p.A- Registration number: 04359090281 in Padova Business Register - All rights
            reserved
        </div>
        <a href="https://www.carel.com" target="_blank">&nbsp;</a>
    </Footer>;
}
